import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BluetoothSearchingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bluetooth_searching"}/>
}
